// ------------------------------------
// Initial State
// ------------------------------------

export const initialState = {
	siteId: 27,
	visitId: null,
	user_ip: null,
	traffic_source_id: null,
	cid: null,
	ctid: null,
	geolocation: {
		city: 'Austin',
		country: 'US',
		region: 'TX',
		latitude: '30.2672',
		longitude: '-97.7431',
	},
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function reducer(state = initialState) {
	return state;
}
